import React from 'react';

const VTechLogo = () => (
  <a 
    href="/" 
    target="_blank" 
    rel="noopener noreferrer"
    className="flex items-center space-x-3 hover:opacity-80 transition-opacity duration-200"
  >
    <img
      src="/images/logo.webp"
      alt="vTech Logo"
      width={180}
      height={160}
      className="h-auto"
    />
  </a>
);

export default VTechLogo;
